<template>
    <b-modal id="tvConfigurationSettingsModal" hide-backdrop centered :no-close-on-esc="true"
            v-bind:title="tvConfigTitle" title-class="test" :ok-title="tvConfigOkTitle"  size="xl" @ok="handleTvConfigSettings"
            @hidden="closeTvConfigurationSettingsModal" @cancel="closeTvConfigurationSettingsModal" @shown="fetchTvSettingsList" modal-class="custom-modal-tv-settings" cancel-title="Close">
            <div class="modal-container">
              <div class="config-list-container">
                <div class="add-tv-settings-btns">
                  <button class="add-tv-setting-btn mb-3 " @click="addTvSettings" title="Add New Tv Setting">Add New</button>
                <button class="add-tv-setting-btn mb-3" @click="addTvSettingsDefault" title="Add Default Tv Setting">Add from Default List</button>
                </div>
                <div v-for="item in tvSettingslist.value" :key="item.code">
                  <div class="actionWrapperRow row  mb-2 m-0  col-12 p-0">
                          <div class="col-9 actionWrapperRowHeading p-0">
                            {{ item.code }}
                          </div>
                          <div class="col-3 p-0 text-right" @click="editTvSettings(item)">
                            <div disabled="true" class="actionBtn" id="btnSendOnboarding">
                              <img src="../../assets/images/edit.svg" width="16" />
                            </div>
                          </div>
                        </div>
  
                </div>
  
              </div>
  
    <div class="tv-settings-args-edit-container" v-if="enableSettingsArgContainer">
      <div class="edit-form-container">
        <div style="" class="tv-config-form-1-container">
        <label class="m-0">Text</label>
        <input
          v-model="tvText"
          type="text"
          placeholder="Enter text value"
          class="tv-config-input-box"
          :disabled="editActionTvSettings"
        />
      </div>
      <div class="tv-config-form-1-container">
        <label class="m-0">Code</label>
        <input
          v-model="tvCode"
          type="text"
          placeholder="Enter code value"
          class="tv-config-input-box"
          :disabled="editActionTvSettings"
          />
      </div>
  
        <div v-for="(field, index) in addNewObj" :key="index" class="form-group" style="display: flex; align-items: center; margin-bottom: 10px;">
          <input
            v-model="field.key"
            type="text"
            :disabled="disableRemoveButton(index)"
            placeholder="Enter label"
            class="tv-config-input-box"
            style="flex: 1; margin-right: 5px;"
          /> :
          <input
            v-model="field.value"
            type="text"
            placeholder="Enter value"
            class="tv-config-input-box ml-1"
            style="flex: 1; margin-right: 10px;margin-left:10px"
          />
          <button
            type="button"
            @click="removeField(index)"
            v-if="!disableRemoveButton(index)"
            :class="disableRemoveButton(index)?'disabled-remove':'enabled-remove'"
          >
          Remove
          </button>
        </div>
  
        <button
          type="button"
          @click="addField"
          class="addFieldBtn"
        >
          Add Field
        </button>
      </div>
    </div>
    <div class="tv-settings-args-edit-container" v-if="enableDefaultSettingsContainer">
      <div class="edit-form-container">
  
      <b-form-group label-for="text-select" >
        <label  >Text </label>
                      <b-form-select v-model="tvText" class="m-12" id="text-select" :options="defaultTextList" @input="addDefaultContainerList(tvText)">
  
                      </b-form-select>
      </b-form-group>
      <div v-for="(field, index) in addNewObj" :key="index" class="form-group" style="display: flex; align-items: center; margin-bottom: 10px;">
          <input
            v-model="field.key"
            type="text"
            :disabled="disableRemoveButtonDefault(index)"
            placeholder="Enter label"
            class="tv-config-input-box"
            style="flex: 1; margin-right: 5px;"
            v-if="!disableRemoveButtonDefault(index)"
          /><div v-if="!disableRemoveButtonDefault(index)"> :</div>
          <label class="tv-config-input-box ml-1" v-if="disableRemoveButtonDefault(index)">{{ field.key }}</label>
          <input
            v-model="field.value"
            type="text"
            placeholder="Enter value"
            class="tv-config-input-box ml-1"
            style="flex: 1;margin-left:10px"
          />
          <button
            type="button"
            @click="removeField(index)"
            v-if="!disableRemoveButtonDefault(index)"
            :class="disableRemoveButtonDefault(index)?'disabled-remove':'enabled-remove'"
          >
          Remove
          </button>
        </div>
        <button
          type="button"
          @click="addField"
          class="addFieldBtn"
          v-if="tvCode!=''"
        >
          Add Field
        </button>
    </div>
  </div>
</div>
</b-modal>
</template>
<script>

import Vue from "vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

Vue.use(Loading);
export default{
    name:"TvConfigAction",
    data(){
        return{
        tvText: "",
        tvCode: "",
        addNewObj: [
          {key: '', value: ''},
        ],
        addNewObjDefault: [
          {key: '', value: ''},
        ],
        
        tvConfigurationSetUpTitle: this.tvConfigTitle,
        enableSettingsArgContainer: false,
        enableDefaultSettingsContainer: false,
        editActionTvSettings: false,
        tvSettingslist: [],
        tvSettingsListDefault: {},
        tvConfigKey: "",
        editObjLength: 0,
        defaultAddObjLength: 0,
        defaultCodeList:[],
        defaultTextList:[],
        tvConfigOkTitle:"Save"
        }
    },
    props:{
      tvConfigTitle :{
        type:String,
        required:true
      },
      tenantOpt:{
        type:String,
        required:true
      },
      showModal:{
        type:Boolean
      }
    },
    computed: {
      jsonData() {
        console.log(this.tvSettingslist,"hello list");
        const data = {};
        const args = {
          "command": "set-app-settings"
        };
        this.addNewObj.forEach(field => {
          if (field.key) {
            args[field.key] = field.value;
          }
        });
        data["args"] = args
        data["text"] = this.tvText;
        data["code"] = this.tvCode;
        data["tenant"] = this.tenantOpt;
        data["key"] = this.tvConfigKey
        return data;
      },
    },
    methods:{
      disableRemoveButton(index) {
        if (this.editActionTvSettings == true) {
          if (index < this.editObjLength)
             return true
           else
            return false
          } else {
              return false
            }

      },
      disableRemoveButtonDefault(index) {
        if (this.enableDefaultSettingsContainer == true) {
           if (index < this.defaultAddObjLength)
            return true
          else
            return false
          } else {
             return false
          }
      },
      addField() {
      this.addNewObj.push({key: '', value: ''});
      },
      removeField(index) {
      this.addNewObj.splice(index, 1);
      },
      async fetchDefaultSettingsList() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var Url = config.OPERATIONS_SERVICE +`/tenants/default/tv-settings`;
      try {
        const res = await fetch(Url, {
          method: "GET",
          mode: "cors",
          withCredentials: true,
          cache: "default",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json"
          }
        });
        if (res.status === 503) {
          return this.fetchDefaultSettingsList();
        } else {
          const newRes = await res.json();
          var defaultList = this.tvSettingsListDefault = newRes[0].value;
          this.defaultCodeList = [];
          this.defaultTextList = [];
          this.tvConfigKey = this.tenantOpt + "_tv_settings";
          for (let i = 0; i < defaultList.length - 1; i++) {
            this.defaultCodeList.push({value: defaultList[i].code, text: defaultList[i].code})
            this.defaultTextList.push({value: defaultList[i].text, text: defaultList[i].text})
          }


        }
      } catch (err) {
        console.log(err);
      }
      },
      async fetchTvSettingsList() {
      let loader = Vue.$loading.show({
        // Optional parameters
        color: "skyblue",
        opacity: 0.1,
        loader: "dots",
      });
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var Url = config.OPERATIONS_SERVICE +`/tenants/${this.tenantOpt}/tv-settings`;
      try {
        const res = await fetch(Url, {
          method: "GET",
          mode: "cors",
          withCredentials: true,
          cache: "default",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json"
          }
        });
        if (res.status === 503) {
          return this.fetchTvSettingsList();
        } else {
          const newRes = await res.json();
          this.tvConfigKey = newRes[0].key
          this.tvSettingslist = newRes[0];
        }
      } catch (err) {
        console.log(err);
      }
      loader.hide();
      },
      addTvSettings() {
      this.addNewObj = [
        {key: '', value: ''},
      ],

      this.enableSettingsArgContainer = true;
      this.enableDefaultSettingsContainer = false;
      this.editActionTvSettings = false;
      this.tvText = "",
      this.tvCode = "",
      this.tvConfigOkTitle="Save";

      },
      addTvSettingsDefault() {
      this.tvConfigOkTitle="Save";
      this.enableSettingsArgContainer = false;
      this.enableDefaultSettingsContainer = true;
      this.editActionTvSettings = false;
      this.fetchDefaultSettingsList();
      this.tvText = "",
          this.tvCode = "",
          this.addNewObj = []
      },
      addDefaultContainerList(tvText) {
      var objList = this.tvSettingsListDefault.find(obj => obj.text == tvText);
      this.tvCode = objList.code
      this.addNewObj = Object.keys(objList.args).map(key => {
        return {
          key: key,
          // value:''
          value: objList.args[key]
        };
      });
      this.defaultAddObjLength = this.addNewObj.length;
      this.tvConfigKey = this.tenantOpt + "_tv_settings";

      },
      async handleTvConfigSettings(event) {
      event.preventDefault();
      if (this.editActionTvSettings == true) {

      await this.updateEditSettings();
      this.editObjLength = this.addNewObj.length;

      }
      else {
        if(this.enableDefaultSettingsContainer==true){
      await this.addTvConfigSettings();
        this.addTvSettingsDefault();

        }
        else{
          await this.addTvConfigSettings();
          this.addTvSettings()

        }

      }
      },
      async addTvConfigSettings() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url = config.OPERATIONS_SERVICE +`/tenants/${this.tenantOpt}/tv-settings`;
      var add_data = new Request(url, {
        method: "POST",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        cache: "default",
        body: JSON.stringify(this.jsonData),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var tvSettingsResponse = await fetch(add_data);
        if (tvSettingsResponse.status === 403) {
          this.errorMessage =
              "Uh oh... You don't have the permission required to insert Tv Config settings";
          Vue.$toast.open({message: this.errorMessage, type: "error"});
          return;
        }
        if (tvSettingsResponse.status == 401) {
          this.errorMessage =
              "Your session has expired please login again to continue";
          Vue.$toast.open({message: this.errorMessage, type: "error"});
          return;
        }
        if (tvSettingsResponse.status == 503) {
          return this.handleTvConfigSettings();
        }
        if (tvSettingsResponse.status != 200) {
          this.commandError = "Failed to insert Tv Config settings";
          Vue.$toast.open({message: this.commandError, type: "error"});
        }
        if (!tvSettingsResponse['ok']) {
          Vue.$toast.open({
            message: "Tv Config Setting with the same id already exists, Please try different.",
            type: "warning"
          });
        } else {
          Vue.$toast.open({
            message:
                "Tv Config settings inserted successfully. Please clear the cache to show effect of the latest.",
            type: "success"
          });
          //clearing the model object on every successfull insertion
        }
        this.fetchTvSettingsList();

      } catch (tex) {
        this.commandError = "Failed to insert Tv settings due to an error.";
        Vue.$toast.open({message: this.commandError, type: "error"});
      }
      },
      async updateEditSettings() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url = config.OPERATIONS_SERVICE +`/tenants/${this.tenantOpt}/tv-settings`;
      var update_data = new Request(url, {
        method: "PATCH",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        cache: "default",
        body: JSON.stringify(this.jsonData),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var tvSettingsResponse = await fetch(update_data);
        if (tvSettingsResponse.status === 403) {
          this.errorMessage =
              "Uh oh... You don't have the permission required to access this resource";
          Vue.$toast.open({message: this.errorMessage, type: "error"});
          return;
        }
        if (tvSettingsResponse.status == 401) {
          this.errorMessage =
              "Your session has expired please login again to continue";
          Vue.$toast.open({message: this.errorMessage, type: "error"});
          return;
        }
        if (tvSettingsResponse.status == 503) {
          return this.updateEditSettings();
        }
        if (tvSettingsResponse.status != 200) {
          this.commandError = "Failed to update Tv Config settings";
          Vue.$toast.open({message: this.commandError, type: "error"});
        } else {
          this.commandError = "";
          Vue.$toast.open({
            message:
                "Tv Config settings updated successfully. Please clear the cache to show effect of the update.",
            type: "success"
          });

          this.fetchTvSettingsList();
          this.defaultAddObjLength = this.addNewObj.length;
          //clearing the model object on every successfull insertion
        }
      } catch (tex) {
        this.commandError = "Failed to update Tv Config settings due to an error.";
        Vue.$toast.open({message: this.commandError, type: "error"});
      }
      },

      closeTvConfigurationSettingsModal() {
      this.$bvModal.hide("tvConfigurationSettingsModal");
      this.editActionTvSettings = false;
      this.enableSettingsArgContainer = false;
      this.enableDefaultSettingsContainer = false;
      this.tvSettingslist = {};
      this.defaultCodeList = [];
      this.defaultTextList = [];
      this.tvConfigOkTitle="Save"
      this.tvText = "",
          this.tvCode = "",
          this.addNewObj = this.addNewObjDefault;
      },
      editTvSettings(item) {
      this.enableSettingsArgContainer = true;
      this.enableDefaultSettingsContainer = false;
      const originalJson = item.args;
      this.tvConfigOkTitle="Update"
      this.addNewObj = Object.keys(originalJson).map(key => {
        return {
          key: key,
          value: originalJson[key]
        };
      });

      this.editObjLength = this.addNewObj.length;
      this.tvText = item.text;
      this.tvCode = item.code;

      this.editActionTvSettings = true

      }
    }
}
</script>
<style scoped lang="scss">
 @import "../../style.scss";
 #tvConfigurationSettingsModal___BV_modal_body_{
      .modal-content{
        height:800px
      }
      .actionWrapperRow{
        padding: 5px !important;
        border: 1px solid #ebebeb;
        border-radius: 5px;
      }
      h2{
        font-size: 20px;
      border-bottom: 1px solid #ebebeb;
      padding-bottom: 15px;
      margin-bottom: 15px;
      }
   .modal-container{
    max-height: 700px;
    overflow-y: auto;
    padding: 0px;
    display: flex;
    background-color: transparent;
    border-radius: 8px;
    /*box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */
   }
  }
  .edit-form-container{
  max-height: 100%;
  overflow-y: auto;
}
 .add-tv-setting-btn{
 padding: 5px 10px;
 background-color: #4CAF50;
 /* display: block; */
  color: white;
   border: none;
   border-radius: 4px;
}
.add-tv-settings-btns{
  display: flex;
  gap: 10px;
}
.tv-config-form-1-container{
  display: flex;
   align-items: center;
    margin-bottom: 10px;
  gap: 10px;
  label{
    min-width: 50px;
  }
}
.tv-config-input-box{
  flex: 1;
}
.addFieldBtn{
  padding: 5px 10px;
   background-color: #4CAF50;
    color: white;
    border: none;
     border-radius: 4px;
}
.disabled-remove{
  flex-shrink: 0;
   padding: 5px 10px;
    background-color: grey;
     color: white;
      border: none;
      border-radius: 4px;
}
.enabled-remove{
  flex-shrink: 0;
   padding: 5px 10px;
    background-color: rgb(240, 24, 24);
     color: white;
      border: none;
      border-radius: 4px;
  margin-left: 10px;
}
.actionBtn img{
  cursor: pointer;
}
.config-list-container {
  max-height: 650px;
  width: 38%;
  margin-right: 15px;
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.tv-settings-args-edit-container {
  max-height: 650px;
  overflow: hidden;
  width: 70%;
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}


</style>